export default __webpack_public_path__ + "static/media/pic1.56b23bb3.jpg";